import React from "react";
import EmergencyCrisis from "../../assets/img/e-crisis.jpg";
import "../WhatDrivesUs.css";

export default function EmergencyCrisisBanner() {
  return (
    <div className="wd-img top-img">
            <img src={EmergencyCrisis} alt="Care Team" />
          </div>
  );
}

